export const isActive = 'is-active'
export const isShow = 'is-show'
export const isHover = 'is-hover'
export const isAnimate = 'is-animate'
export const isHide = 'is-hide'
export const isOpen = 'is-show'
export const isClose = 'is-close'
export const isLocked = 'is-locked'
export const breakpointMD = 897
